import React from 'react'
import { Alert } from 'antd'
import { InfoCircleFilled } from '@ant-design/icons'

interface InformationBoxProps {
  message: string
  description?: string
}

const InformationBox: React.FC<InformationBoxProps> = ({ message, description }) => {
  return (
    <Alert
      message={message}
      description={description}
      type="info"
      icon={<InfoCircleFilled />}
      showIcon
      style={{ marginTop: 0 }}
    />
  )
}

export default InformationBox
